export function getMoreColumnsCount(noOfSubMenus: number) {

    if (noOfSubMenus <= 7) {
        return 1;
    } else if (noOfSubMenus <= 20) {
        return 2;
    } else {
        return 3;
    }
}